// @file screen recorder utilities

export enum ScreenRecorderStatus {
  Hidden = 'Hidden',
  Connecting = 'Connecting',
  Streaming = 'Streaming',
  Recording = 'Recording',
  Paused = 'Paused',
  Previewing = 'Previewing',
  Saving = 'Saving',
}
